import React, { useState } from 'react';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

function ChannelForm({ initial, onSave, onCancel, loading }) {
  const [name, setName] = useState(initial?.name || '');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return setError('Name is required.');
    setError('');
    onSave({ name: name.trim() });
  };

  return (
    <form onSubmit={handleSubmit} style={{ minWidth: 320, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div>
        <label>Name<RequiredMark /></label><br />
        <input
          className="styled-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={100}
          placeholder="e.g., Web Store"
          style={{ width: 300 }}
        />
      </div>

      {error && <div style={{ color: 'red' }}>{error}</div>}

      <div>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default ChannelForm;
